import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
// import { IImage } from 'ng-simple-slideshow';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { UserService } from 'src/app/modules/userModule/shared/user.service';
import { HomeAssets } from 'src/app/models/homeAssets';
import { AssetCardDetails } from 'src/app/models/assetCardDetails';
import { Router } from '@angular/router';
import { Folder } from 'src/app/models/folder';
import { GalleryConfig, GalleryItem, ImageItem, LoadingStrategy } from 'ng-gallery';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  homeAssetsArr: HomeAssets[] = [];
  imageUrlArray = [];
  rootFolders:any;
  theme_color: string;
  images: GalleryItem[];
  options: GalleryConfig | any;

  constructor(private config: ConfigService, private httpService: HttpService, private userService: UserService, private route: Router) {
    this.options = {
      counter : false,
      thumb : false,
      disableThumb: true,
      autoplay : true,
      imageSize: 'cover',
      loadingStrategy: LoadingStrategy.Default
    };
   }


  ngOnInit() {
    // setting the search results and search key as null when user navigates to home page.
    let User = JSON.parse(sessionStorage.getItem('userinfo'));
    this.theme_color = User.userSettings.userThemeType===0?'dark':'light';
    this.httpService.changesearchResults(null, null, null, null);
    this.config.searchActive = false;
    this.config.homeActive = false;
    this.config.personalBrowserActive = false;
    this.config.uploadAssetsActive = false;

    this.config.homeActive = true;
    this.httpService.getBasePath().then(res => {
      this.getHomePageAssets();
    }, err => { console.log(err) });
  }

  /**Get homepage asset api call */
  getHomePageAssets() {
    this.imageUrlArray.push(
      { url: 'assets/img/4.jpg', clickAction: () => this.navigateToSearchTheLib()},
      { url: 'assets/img/2.jpg', clickAction: () => this.navigateToSearchTheLib()},
      { url: 'assets/img/1.jpg', clickAction: () => this.navigateToSearchTheLib()},
      { url: 'assets/img/5.jpg', clickAction: () => this.navigateToSearchTheLib()}
    ); 
    this.images = this.imageUrlArray.map(img=> new ImageItem({src:img.url}));
    this.httpService.getRootFolderData(this.userService.loggendInUser.userEmailId).subscribe((res:any)=>{
      this.homeAssetsArr=res[0].subFolders;
      this.getAssetForRootFolders();
    },
    (err)=>{
      console.log(err);
    });

    // Home page asset call
    // this.httpService.getHomePageAssets(this.userService.loggendInUser.userEmailId).subscribe(
    //   (res: HomeAssets[]) => {
    //     console.log('Initial',res);
    //     this.homeAssetsArr = res;
        
    //     /**Populating the image slider array */
    //     // for (let i = 0; i < this.homeAssetsArr.length; i++) {

    //     //   this.imageUrlArray.push({ url: 'https://cdn.vox-cdn.com/uploads/chorus_image/image/56789263/akrales_170919_1976_0104.0.jpg', clickAction: () => this.navigateToSearchTheLib(this.homeAssetsArr[i].folderId) });
    //     // }


    //   },
    //   (err) => {
    //     console.log(err);
    //   }
    // );
  }
  
  /**
   * Calling the search api to get the latest five asset in each root folder
   */
  getAssetForRootFolders()
  {
      this.homeAssetsArr.forEach(folder => {
        this.httpService.searchAssets(' ',this.userService.loggendInUser.userEmailId,folder._id).subscribe(
          (res:any)=>
          {
            folder.assetCards=res.searchResults.assets;
            //If there are more than  5 asset.Take the latest 5
            if(folder.assetCards.length>5)
            {
              folder.assetCards=folder.assetCards.slice(-5).reverse();
            }
            //else take all the asset if less than 5
            else{
              folder.assetCards=folder.assetCards.reverse();
            }
            
            // console.log(`---${folder.name}---`);
            // folder.assetCards.forEach(asset=>{console.log(asset.creationDate)}); 
          },(err)=>{
            console.log(err);
          }
        );
      });
      
  }
  /** Navigate to search the lib*/
  navigateToSearchTheLib() {
    this.route.navigateByUrl(`/val-assets/search`);

  }
  /**
   * Adding Router in the home page on selecting the folder.
   * @param folderName - name of the folder which is clicked.
   */
  navigateUrl(folderName) {
    this.httpService.folder2ndround = false;
    sessionStorage.setItem('folderRefresh', 'true');
    this.route.navigateByUrl(`/val-assets/search/folders/${folderName}`);
  }
}
